import { state } from './state.js';

export const LANGS = [
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'uz', label: "O'zbek", short: 'UZ' },
  { code: 'ru', label: 'Русский', short: 'RU' },
  { code: 'kz', label: 'Қазақша', short: 'KZ' },
  { code: 'kg', label: 'Кыргызча', short: 'KG' },
  { code: 'tj', label: 'Тоҷикӣ', short: 'TJ' },
  { code: 'tm', label: 'Türkmençe', short: 'TM' },
];

export const CURRENCIES = [
  { code: 'UZS', label: "UZS · so'm" },
  { code: 'USD', label: 'USD · $' },
  { code: 'EUR', label: 'EUR · €' },
  { code: 'RUB', label: 'RUB · ₽' },
];

// Static rates from UZS to other currencies. Rough mid-2026 figures —
// in production these'd come from a daily FX feed.
const RATES_FROM_UZS = {
  UZS: 1,
  USD: 1 / 12500,
  EUR: 1 / 13500,
  RUB: 1 / 130,
};

export const T = {
  en: {
    'sp.tag': 'Rooms by the hour · Uzbekistan',
    'sp.live.label': 'rooms live · 6 cities',
    'sp.title.1': 'Skip the night.',
    'sp.title.2.before': 'Book the ',
    'sp.title.2.hour': 'hour',
    'sp.title.2.after': '.',
    'sp.lede':
      "Hotels release empty rooms last-minute. Pick a city to see what's free right now on the map.",
    'sp.pick': 'Select city',
    'sp.pick.cta': 'Tap to start',
    'sp.locate': 'Use my location',
    'sp.locating': 'Locating…',
    'sp.trust': 'No deposit · Free cancellation · Pay at the hotel',
    'sp.live.unit': 'live',
    'stories.title': 'Featured stays',
    'stories.cta': 'Book this room',
    'explore.title': 'Explore by location & topic',
    'explore.cities': 'Cities',
    'explore.topics': 'Topics',
    'explore.nearby': 'Nearby',

    'top.city': 'City',
    'top.day': 'Day use',
    'top.night': 'Tonight',

    'card.left': '{n} left',
    'card.book': 'Book',
    'card.window.day': '{win} · pick a start time',
    'card.window.night': 'Tonight · 1 night',
    'card.dayblock': '{n}h day-use block',
    'card.empty.h': 'No saved rooms in {city} yet.',
    'card.empty.s': 'Tap the heart on any room to save it for later.',
    'card.empty.cta': 'Show all rooms →',

    'detail.book.day': 'Book this room',
    'detail.book.night': 'Book tonight',
    'detail.fine':
      'No deposit · free cancellation up to 1h before · pay at the hotel',
    'detail.window': 'Window',
    'detail.stay': 'Stay',
    'detail.mode': 'Mode',
    'detail.dayuse': 'Day use · {n}h',
    'detail.overnight': 'Overnight',
    'detail.tonight': 'Tonight · 1 night',
    'detail.rooms.left': '{n} rooms left',
    'detail.tonight.tag': 'tonight',

    'book.stay': 'Stay',
    'book.dayuse': 'Day use',
    'book.overnight': 'Overnight',
    'book.when': 'When',
    'book.guests': 'Guests',
    'book.guests.value': '2 adults',
    'book.saving': 'Saving',
    'book.youpay': 'You pay',
    'book.confirm': 'Confirm booking',
    'book.fine':
      'No deposit · free cancellation up to 1h before · pay at the hotel',
    'book.when.day': '{slot} · {n} hrs',

    'booked.t': 'Booked',
    'booked.head': "You're in.",
    'booked.code': 'Show this code at the front desk',
    'booked.pay': 'pay on arrival',
    'booked.done': 'Done',
    'booked.confirmation': 'A confirmation has been sent to your phone.',

    'city.t': 'Change city',
    'city.s': 'Live rooms in 6 cities',

    'settings.t': 'Settings',
    'settings.s': 'Language and currency',
    'settings.lang': 'Language',
    'settings.currency': 'Currency',
    'settings.done': 'Done',

    'seo.cta.openapp': 'Open the app →',
    'seo.cta.findRooms': 'Find rooms now →',
    'seo.crumb.home': 'Home',
    'seo.section.numbers': 'By the numbers',
    'seo.section.faq': 'Frequently asked questions',
    'seo.section.refs': 'Sources & references',
    'seo.section.refsIntro':
      'Every figure on this page links back to a primary or reputable secondary source. Tourism data in Central Asia moves quickly — figures should be re-verified annually.',
    'seo.section.cities': 'Cities with live inventory',
    'seo.section.cluster': 'Where the inventory clusters',
    'seo.section.otherCities': 'Other cities in {country}',
    'seo.section.guides': 'Topic guides',
    'seo.section.bycity': 'By city',
    'seo.eyebrow.country': '{name} · Country hub',
    'seo.eyebrow.city': '{country} · City',
    'seo.eyebrow.topic': 'Topic guide',
    'seo.foot.uz': 'Uzbekistan',
    'seo.foot.topics': 'Topics',
    'seo.foot.region': 'Region',
    'seo.foot.about': 'About',
    'seo.foot.tagline':
      'Last-minute and day-use hotel rooms across Uzbekistan and Central Asia. Real-time availability, no deposit, pay at the hotel.',
    'seo.foot.bottom':
      'Every numeric claim is sourced inline and consolidated at the bottom of each page.',
    'seo.foot.openapp': 'Open booking app',
    'seo.lang.aria': 'Choose language',
  },
  uz: {
    'sp.tag': "Soatlik xonalar · O'zbekiston",
    'sp.live.label': "xona mavjud · 6 shahar bo'ylab",
    'sp.title.1': 'Tundan voz keching.',
    'sp.title.2.before': '',
    'sp.title.2.hour': 'Soatga',
    'sp.title.2.after': ' oling.',
    'sp.lede':
      "Mehmonxonalar bo'sh xonalarni so'nggi daqiqada chiqaradi. Hozir nima bo'shligini ko'rish uchun shaharni tanlang.",
    'sp.pick': 'Shaharni tanlang',
    'sp.pick.cta': 'Boshlash uchun bosing',
    'sp.locate': 'Joylashuvimdan foydalanish',
    'sp.locating': 'Aniqlanmoqda…',
    'sp.trust': "Depozitsiz · Bekor qilish bepul · Mehmonxonada to'lov",
    'sp.live.unit': 'mavjud',
    'stories.title': 'Tavsiya etilgan xonalar',
    'stories.cta': 'Bu xonani band qilish',
    'explore.title': "Joylashuv va mavzu bo'yicha",
    'explore.cities': 'Shaharlar',
    'explore.topics': 'Mavzular',
    'explore.nearby': 'Atrofdagi',

    'top.city': 'Shahar',
    'top.day': 'Kunlik',
    'top.night': 'Bu oqshom',

    'card.left': '{n} ta qoldi',
    'card.book': 'Olish',
    'card.window.day': '{win} · vaqtni tanlang',
    'card.window.night': 'Bu oqshom · 1 tun',
    'card.dayblock': '{n} soatlik kunlik blok',
    'card.empty.h': "{city}da hali saqlangan xona yo'q.",
    'card.empty.s': 'Saqlash uchun istalgan xonadagi yurakka bosing.',
    'card.empty.cta': 'Barcha xonalar →',

    'detail.book.day': 'Bu xonani band qilish',
    'detail.book.night': 'Bu oqshomga olish',
    'detail.fine':
      "Depozitsiz · 1 soat oldin bekor qilish bepul · mehmonxonada to'lov",
    'detail.window': "Vaqt oralig'i",
    'detail.stay': 'Turish',
    'detail.mode': 'Rejim',
    'detail.dayuse': 'Kunlik · {n} soat',
    'detail.overnight': 'Tunash',
    'detail.tonight': 'Bu oqshom · 1 tun',
    'detail.rooms.left': '{n} ta xona qoldi',
    'detail.tonight.tag': 'bu oqshom',

    'book.stay': 'Turish',
    'book.dayuse': 'Kunlik',
    'book.overnight': 'Tunash',
    'book.when': 'Qachon',
    'book.guests': 'Mehmonlar',
    'book.guests.value': '2 katta yoshli',
    'book.saving': 'Tejash',
    'book.youpay': "Toʻlov",
    'book.confirm': 'Buyurtmani tasdiqlash',
    'book.fine':
      "Depozitsiz · 1 soat oldin bekor qilish bepul · mehmonxonada to'lov",
    'book.when.day': '{slot} · {n} soat',

    'booked.t': 'Band qilindi',
    'booked.head': 'Tayyor!',
    'booked.code': "Qabulda ushbu kodni ko'rsating",
    'booked.pay': "kelganda to'laysiz",
    'booked.done': 'Tugadi',
    'booked.confirmation': 'Tasdiq sizning telefoningizga yuborildi.',

    'city.t': 'Shaharni almashtirish',
    'city.s': '6 shahardagi mavjud xonalar',

    'settings.t': 'Sozlamalar',
    'settings.s': 'Til va valyuta',
    'settings.lang': 'Til',
    'settings.currency': 'Valyuta',
    'settings.done': 'Tugadi',

    'seo.cta.openapp': 'Ilovani ochish →',
    'seo.cta.findRooms': 'Hozir xonalar topish →',
    'seo.crumb.home': 'Bosh sahifa',
    'seo.section.numbers': 'Raqamlarda',
    'seo.section.faq': 'Tez-tez beriladigan savollar',
    'seo.section.refs': "Manbalar va havolalar",
    'seo.section.refsIntro':
      "Ushbu sahifadagi har bir raqam birlamchi yoki obro'li ikkilamchi manbaga bog'lanadi. Markaziy Osiyodagi turizm ma'lumotlari tez o'zgaradi — raqamlar har yili qayta tekshirilishi kerak.",
    'seo.section.cities': "Mavjud xonalar bo'lgan shaharlar",
    'seo.section.cluster': "Xonalar to'plangan joylar",
    'seo.section.otherCities': "{country}dagi boshqa shaharlar",
    'seo.section.guides': "Mavzuli qo'llanmalar",
    'seo.section.bycity': "Shaharlar bo'yicha",
    'seo.eyebrow.country': '{name} · Mamlakat sahifasi',
    'seo.eyebrow.city': "{country} · Shahar",
    'seo.eyebrow.topic': "Mavzuli qo'llanma",
    'seo.foot.uz': "O'zbekiston",
    'seo.foot.topics': 'Mavzular',
    'seo.foot.region': 'Mintaqa',
    'seo.foot.about': "Kompaniya haqida",
    'seo.foot.tagline':
      "O'zbekiston va Markaziy Osiyo bo'ylab so'nggi daqiqada va kunlik xonalar. Real vaqtdagi mavjudlik, depozitsiz, mehmonxonada to'lov.",
    'seo.foot.bottom':
      "Har bir raqam sahifa ichida manba bilan keltiriladi va sahifa pastida jamlanadi.",
    'seo.foot.openapp': 'Bron ilovasi',
    'seo.lang.aria': 'Tilni tanlash',
  },
  ru: {
    'sp.tag': 'Номера на час · Узбекистан',
    'sp.live.label': 'номеров свободно · 6 городов',
    'sp.title.1': 'Пропусти ночь.',
    'sp.title.2.before': 'Бери на ',
    'sp.title.2.hour': 'час',
    'sp.title.2.after': '.',
    'sp.lede':
      'Отели выставляют свободные номера в последнюю минуту. Выберите город, чтобы увидеть, что свободно прямо сейчас.',
    'sp.pick': 'Выберите город',
    'sp.pick.cta': 'Нажмите, чтобы начать',
    'sp.locate': 'Моё местоположение',
    'sp.locating': 'Определяем…',
    'sp.trust': 'Без депозита · Бесплатная отмена · Оплата в отеле',
    'sp.live.unit': 'своб.',
    'stories.title': 'Рекомендуем',
    'stories.cta': 'Забронировать',
    'explore.title': 'Все направления и темы',
    'explore.cities': 'Города',
    'explore.topics': 'Темы',
    'explore.nearby': 'Рядом',

    'top.city': 'Город',
    'top.day': 'Дневной',
    'top.night': 'Сегодня',

    'card.left': 'осталось {n}',
    'card.book': 'Взять',
    'card.window.day': '{win} · выберите время',
    'card.window.night': 'Сегодня · 1 ночь',
    'card.dayblock': 'Блок на {n} ч',
    'card.empty.h': 'В {city} нет сохранённых номеров.',
    'card.empty.s': 'Нажмите ♡ на любом номере, чтобы сохранить.',
    'card.empty.cta': 'Показать все →',

    'detail.book.day': 'Забронировать',
    'detail.book.night': 'Взять на ночь',
    'detail.fine':
      'Без депозита · бесплатная отмена за 1 ч · оплата в отеле',
    'detail.window': 'Окно',
    'detail.stay': 'Тип',
    'detail.mode': 'Режим',
    'detail.dayuse': 'Дневной · {n} ч',
    'detail.overnight': 'Ночь',
    'detail.tonight': 'Сегодня · 1 ночь',
    'detail.rooms.left': 'осталось {n} номеров',
    'detail.tonight.tag': 'сегодня',

    'book.stay': 'Тип',
    'book.dayuse': 'Дневной',
    'book.overnight': 'Ночь',
    'book.when': 'Когда',
    'book.guests': 'Гости',
    'book.guests.value': '2 взрослых',
    'book.saving': 'Экономия',
    'book.youpay': 'К оплате',
    'book.confirm': 'Подтвердить',
    'book.fine':
      'Без депозита · бесплатная отмена за 1 ч · оплата в отеле',
    'book.when.day': '{slot} · {n} ч',

    'booked.t': 'Готово',
    'booked.head': 'Вы в деле.',
    'booked.code': 'Покажите этот код на ресепшен',
    'booked.pay': 'оплата по приезду',
    'booked.done': 'Закрыть',
    'booked.confirmation': 'Подтверждение отправлено на ваш телефон.',

    'city.t': 'Сменить город',
    'city.s': 'Свободные номера в 6 городах',

    'settings.t': 'Настройки',
    'settings.s': 'Язык и валюта',
    'settings.lang': 'Язык',
    'settings.currency': 'Валюта',
    'settings.done': 'Готово',

    'seo.cta.openapp': 'Открыть приложение →',
    'seo.cta.findRooms': 'Найти номер сейчас →',
    'seo.crumb.home': 'Главная',
    'seo.section.numbers': 'В цифрах',
    'seo.section.faq': 'Частые вопросы',
    'seo.section.refs': 'Источники',
    'seo.section.refsIntro':
      'Каждая цифра на этой странице ссылается на первичный или авторитетный вторичный источник. Туристические данные в Центральной Азии быстро меняются — цифры стоит сверять ежегодно.',
    'seo.section.cities': 'Города с живой загрузкой',
    'seo.section.cluster': 'Где сосредоточены номера',
    'seo.section.otherCities': 'Другие города в {country}',
    'seo.section.guides': 'Тематические гиды',
    'seo.section.bycity': 'По городам',
    'seo.eyebrow.country': '{name} · Страница страны',
    'seo.eyebrow.city': '{country} · Город',
    'seo.eyebrow.topic': 'Тематический гид',
    'seo.foot.uz': 'Узбекистан',
    'seo.foot.topics': 'Темы',
    'seo.foot.region': 'Регион',
    'seo.foot.about': 'О проекте',
    'seo.foot.tagline':
      'Номера на час, день и в последнюю минуту по Узбекистану и Центральной Азии. Загрузка в реальном времени, без депозита, оплата в отеле.',
    'seo.foot.bottom':
      'Каждая цифра подкреплена ссылкой на источник в самом тексте и в перечне внизу страницы.',
    'seo.foot.openapp': 'Открыть приложение',
    'seo.lang.aria': 'Выбрать язык',
  },
  kz: {
    'sp.tag': 'Сағаттық қонақ үйлер · Орталық Азия',
    'sp.live.label': 'бөлме бос · 6 қала',
    'sp.title.1': 'Түнді өткізіңіз.',
    'sp.title.2.before': 'Бір ',
    'sp.title.2.hour': 'сағатқа',
    'sp.title.2.after': ' алыңыз.',
    'sp.lede':
      'Қонақ үйлер бос бөлмелерді соңғы минутта босатады. Қазір не бос екенін көру үшін қаланы таңдаңыз.',
    'sp.pick': 'Қаланы таңдаңыз',
    'sp.pick.cta': 'Бастау үшін басыңыз',
    'sp.locate': 'Менің орналасуым',
    'sp.locating': 'Анықталуда…',
    'sp.trust': 'Депозитсіз · Тегін бас тарту · Қонақ үйде төлеу',
    'sp.live.unit': 'бос',
    'stories.title': 'Ұсынылатын',
    'stories.cta': 'Бөлмені брондау',
    'explore.title': 'Орналасу мен тақырып бойынша',
    'explore.cities': 'Қалалар',
    'explore.topics': 'Тақырыптар',
    'explore.nearby': 'Жақын маңда',

    'top.city': 'Қала',
    'top.day': 'Күндізгі',
    'top.night': 'Бүгін',

    'card.left': '{n} қалды',
    'card.book': 'Алу',
    'card.window.day': '{win} · уақытты таңдаңыз',
    'card.window.night': 'Бүгін · 1 түн',
    'card.dayblock': '{n} сағаттық күндізгі блок',
    'card.empty.h': '{city} қаласында сақталған бөлме жоқ.',
    'card.empty.s': 'Сақтау үшін кез келген бөлмедегі жүректі басыңыз.',
    'card.empty.cta': 'Барлық бөлмелер →',

    'detail.book.day': 'Бұл бөлмені брондау',
    'detail.book.night': 'Бүгінге алу',
    'detail.fine':
      'Депозитсіз · 1 сағат бұрын тегін бас тарту · қонақ үйде төлеу',
    'detail.window': 'Уақыт',
    'detail.stay': 'Тұру',
    'detail.mode': 'Режим',
    'detail.dayuse': 'Күндізгі · {n} сағ',
    'detail.overnight': 'Түнгі',
    'detail.tonight': 'Бүгін · 1 түн',
    'detail.rooms.left': '{n} бөлме қалды',
    'detail.tonight.tag': 'бүгін',

    'book.stay': 'Тұру',
    'book.dayuse': 'Күндізгі',
    'book.overnight': 'Түнгі',
    'book.when': 'Қашан',
    'book.guests': 'Қонақтар',
    'book.guests.value': '2 ересек',
    'book.saving': 'Үнемдеу',
    'book.youpay': 'Төлем',
    'book.confirm': 'Растау',
    'book.fine':
      'Депозитсіз · 1 сағат бұрын тегін бас тарту · қонақ үйде төлеу',
    'book.when.day': '{slot} · {n} сағ',

    'booked.t': 'Брондалды',
    'booked.head': 'Дайын!',
    'booked.code': 'Қабылдау бөлімінде осы кодты көрсетіңіз',
    'booked.pay': 'келгенде төлейсіз',
    'booked.done': 'Жабу',
    'booked.confirmation': 'Растау сіздің телефоныңызға жіберілді.',

    'city.t': 'Қаланы өзгерту',
    'city.s': '6 қаладағы бос бөлмелер',

    'settings.t': 'Параметрлер',
    'settings.s': 'Тіл мен валюта',
    'settings.lang': 'Тіл',
    'settings.currency': 'Валюта',
    'settings.done': 'Дайын',

    'seo.cta.openapp': 'Қолданбаны ашу →',
    'seo.cta.findRooms': 'Қазір бөлме табу →',
    'seo.crumb.home': 'Басты бет',
    'seo.section.numbers': 'Сандарда',
    'seo.section.faq': 'Жиі қойылатын сұрақтар',
    'seo.section.refs': 'Дереккөздер',
    'seo.section.refsIntro':
      'Осы беттегі әрбір сан бастапқы немесе беделді қайталама дереккөзге сілтейді. Орталық Азиядағы туризм деректері тез өзгереді — сандарды жыл сайын тексеру керек.',
    'seo.section.cities': 'Бос бөлмелері бар қалалар',
    'seo.section.cluster': 'Бөлмелер шоғырланған жерлер',
    'seo.section.otherCities': '{country} ішіндегі басқа қалалар',
    'seo.section.guides': 'Тақырыптық нұсқаулықтар',
    'seo.section.bycity': 'Қалалар бойынша',
    'seo.eyebrow.country': '{name} · Ел беті',
    'seo.eyebrow.city': '{country} · Қала',
    'seo.eyebrow.topic': 'Тақырыптық нұсқаулық',
    'seo.foot.uz': 'Өзбекстан',
    'seo.foot.topics': 'Тақырыптар',
    'seo.foot.region': 'Аймақ',
    'seo.foot.about': 'Жоба туралы',
    'seo.foot.tagline':
      'Өзбекстан мен Орталық Азия бойынша сағаттық, күндізгі және соңғы минуттық бөлмелер. Нақты уақыттағы бос бөлмелер, депозитсіз, қонақ үйде төлеу.',
    'seo.foot.bottom':
      'Әрбір сан мәтін ішінде дереккөзбен расталған және беттің төменгі бөлігінде жиналған.',
    'seo.foot.openapp': 'Қолданбаны ашу',
    'seo.lang.aria': 'Тіл таңдау',
  },
  kg: {
    'sp.tag': 'Сааттык мейманканалар · Борбордук Азия',
    'sp.live.label': 'бөлмө бош · 6 шаар',
    'sp.title.1': 'Түндү өткөрүп жибериңиз.',
    'sp.title.2.before': 'Бир ',
    'sp.title.2.hour': 'саатка',
    'sp.title.2.after': ' алыңыз.',
    'sp.lede':
      'Мейманканалар бош бөлмөлөрдү акыркы мүнөттө чыгарат. Азыр эмне бош экенин көрүү үчүн шаарды тандаңыз.',
    'sp.pick': 'Шаарды тандаңыз',
    'sp.pick.cta': 'Баштоо үчүн басыңыз',
    'sp.locate': 'Менин жайгашуум',
    'sp.locating': 'Аныкталууда…',
    'sp.trust': 'Депозитсиз · Бекер жокко чыгаруу · Мейманканада төлөө',
    'sp.live.unit': 'бош',
    'stories.title': 'Сунушталган',
    'stories.cta': 'Бөлмөнү ээлеп коюу',
    'explore.title': 'Жайгашуу жана тема боюнча',
    'explore.cities': 'Шаарлар',
    'explore.topics': 'Темалар',
    'explore.nearby': 'Жакын',

    'top.city': 'Шаар',
    'top.day': 'Күндүзгү',
    'top.night': 'Бүгүн',

    'card.left': '{n} калды',
    'card.book': 'Алуу',
    'card.window.day': '{win} · убакытты тандаңыз',
    'card.window.night': 'Бүгүн · 1 түн',
    'card.dayblock': '{n} сааттык күндүзгү блок',
    'card.empty.h': '{city} шаарында сакталган бөлмө жок.',
    'card.empty.s': 'Сактоо үчүн каалаган бөлмөдөгү жүрөктү басыңыз.',
    'card.empty.cta': 'Бардык бөлмөлөр →',

    'detail.book.day': 'Бул бөлмөнү ээлеп коюу',
    'detail.book.night': 'Бүгүнгө алуу',
    'detail.fine':
      'Депозитсиз · 1 саат мурун бекер жокко чыгаруу · мейманканада төлөө',
    'detail.window': 'Убакыт',
    'detail.stay': 'Туруу',
    'detail.mode': 'Режим',
    'detail.dayuse': 'Күндүзгү · {n} с',
    'detail.overnight': 'Түнгү',
    'detail.tonight': 'Бүгүн · 1 түн',
    'detail.rooms.left': '{n} бөлмө калды',
    'detail.tonight.tag': 'бүгүн',

    'book.stay': 'Туруу',
    'book.dayuse': 'Күндүзгү',
    'book.overnight': 'Түнгү',
    'book.when': 'Качан',
    'book.guests': 'Меймандар',
    'book.guests.value': '2 чоң киши',
    'book.saving': 'Үнөмдөө',
    'book.youpay': 'Төлөм',
    'book.confirm': 'Ырастоо',
    'book.fine':
      'Депозитсиз · 1 саат мурун бекер жокко чыгаруу · мейманканада төлөө',
    'book.when.day': '{slot} · {n} с',

    'booked.t': 'Ээлеп коюлду',
    'booked.head': 'Даяр!',
    'booked.code': 'Кабыл алуу бөлүмүндө бул кодду көрсөтүңүз',
    'booked.pay': 'келгенде төлөйсүз',
    'booked.done': 'Жабуу',
    'booked.confirmation': 'Ырастоо телефонуңузга жөнөтүлдү.',

    'city.t': 'Шаарды өзгөртүү',
    'city.s': '6 шаардагы бош бөлмөлөр',

    'settings.t': 'Параметрлер',
    'settings.s': 'Тил жана валюта',
    'settings.lang': 'Тил',
    'settings.currency': 'Валюта',
    'settings.done': 'Даяр',

    'seo.cta.openapp': 'Колдонмону ачуу →',
    'seo.cta.findRooms': 'Азыр бөлмө табуу →',
    'seo.crumb.home': 'Башкы бет',
    'seo.section.numbers': 'Сандарда',
    'seo.section.faq': 'Көп берилүүчү суроолор',
    'seo.section.refs': 'Булактар',
    'seo.section.refsIntro':
      'Бул беттеги ар бир сан баштапкы же кадыр-барктуу экинчилик булакка шилтейт. Борбордук Азиядагы туризм маалыматтары тез өзгөрөт — сандар жыл сайын кайра текшерилиши керек.',
    'seo.section.cities': 'Бош бөлмөлөрү бар шаарлар',
    'seo.section.cluster': 'Бөлмөлөр топтолгон жерлер',
    'seo.section.otherCities': '{country} ичиндеги башка шаарлар',
    'seo.section.guides': 'Тематикалык колдонмолор',
    'seo.section.bycity': 'Шаарлар боюнча',
    'seo.eyebrow.country': '{name} · Өлкө бети',
    'seo.eyebrow.city': '{country} · Шаар',
    'seo.eyebrow.topic': 'Тематикалык колдонмо',
    'seo.foot.uz': 'Өзбекстан',
    'seo.foot.topics': 'Темалар',
    'seo.foot.region': 'Аймак',
    'seo.foot.about': 'Долбоор жөнүндө',
    'seo.foot.tagline':
      'Өзбекстан жана Борбордук Азия боюнча сааттык, күндүзгү жана акыркы мүнөттөгү бөлмөлөр. Реалдуу убакыттагы бош бөлмөлөр, депозитсиз, мейманканада төлөө.',
    'seo.foot.bottom':
      'Ар бир сан текстте булагы менен келтирилет жана беттин аягында жыйналат.',
    'seo.foot.openapp': 'Колдонмону ачуу',
    'seo.lang.aria': 'Тил тандоо',
  },
  tj: {
    'sp.tag': 'Меҳмонхонаҳои соатӣ · Осиёи Марказӣ',
    'sp.live.label': 'ҳуҷра дастрас · 6 шаҳр',
    'sp.title.1': 'Шабро гузаронед.',
    'sp.title.2.before': 'Як ',
    'sp.title.2.hour': 'соат',
    'sp.title.2.after': ' гиред.',
    'sp.lede':
      'Меҳмонхонаҳо ҳуҷраҳои холиро дар лаҳзаи охир мебароранд. Барои дидани он чи ҳозир холӣ аст, шаҳрро интихоб кунед.',
    'sp.pick': 'Шаҳрро интихоб кунед',
    'sp.pick.cta': 'Барои оғоз пахш кунед',
    'sp.locate': 'Ҷойгиршавии ман',
    'sp.locating': 'Муайян карда мешавад…',
    'sp.trust': 'Бе пешпардохт · Бекоркунӣ ройгон · Дар меҳмонхона пардохт',
    'sp.live.unit': 'дастрас',
    'stories.title': 'Тавсияшаванда',
    'stories.cta': 'Ҳуҷраро гирифтан',
    'explore.title': 'Аз рӯи ҷойгиршавӣ ва мавзӯъ',
    'explore.cities': 'Шаҳрҳо',
    'explore.topics': 'Мавзӯъҳо',
    'explore.nearby': 'Дар наздикӣ',

    'top.city': 'Шаҳр',
    'top.day': 'Рӯзона',
    'top.night': 'Имшаб',

    'card.left': '{n} мондааст',
    'card.book': 'Гирифтан',
    'card.window.day': '{win} · вақтро интихоб кунед',
    'card.window.night': 'Имшаб · 1 шаб',
    'card.dayblock': 'Блоки {n} соата',
    'card.empty.h': 'Дар {city} ҳуҷраи нигоҳдошташуда нест.',
    'card.empty.s': 'Барои нигоҳ доштан, дар ҳар ҳуҷра дилро пахш кунед.',
    'card.empty.cta': 'Ҳамаи ҳуҷраҳо →',

    'detail.book.day': 'Ҳамин ҳуҷраро гирифтан',
    'detail.book.night': 'Барои имшаб гирифтан',
    'detail.fine':
      'Бе пешпардохт · бекоркунии ройгон 1 соат пеш · дар меҳмонхона пардохт',
    'detail.window': 'Вақт',
    'detail.stay': 'Зист',
    'detail.mode': 'Реҷа',
    'detail.dayuse': 'Рӯзона · {n} соат',
    'detail.overnight': 'Шабона',
    'detail.tonight': 'Имшаб · 1 шаб',
    'detail.rooms.left': '{n} ҳуҷра мондааст',
    'detail.tonight.tag': 'имшаб',

    'book.stay': 'Зист',
    'book.dayuse': 'Рӯзона',
    'book.overnight': 'Шабона',
    'book.when': 'Кай',
    'book.guests': 'Меҳмонон',
    'book.guests.value': '2 калонсол',
    'book.saving': 'Сарфакорӣ',
    'book.youpay': 'Пардохт',
    'book.confirm': 'Тасдиқ',
    'book.fine':
      'Бе пешпардохт · бекоркунии ройгон 1 соат пеш · дар меҳмонхона пардохт',
    'book.when.day': '{slot} · {n} соат',

    'booked.t': 'Гирифта шуд',
    'booked.head': 'Тайёр!',
    'booked.code': 'Дар қабул ин кодро нишон диҳед',
    'booked.pay': 'ҳангоми омадан мепардозед',
    'booked.done': 'Бастан',
    'booked.confirmation': 'Тасдиқ ба телефонатон фиристода шуд.',

    'city.t': 'Шаҳрро тағйир додан',
    'city.s': 'Дар 6 шаҳр ҳуҷраҳои дастрас',

    'settings.t': 'Танзимҳо',
    'settings.s': 'Забон ва асъор',
    'settings.lang': 'Забон',
    'settings.currency': 'Асъор',
    'settings.done': 'Тайёр',

    'seo.cta.openapp': 'Кушодани барнома →',
    'seo.cta.findRooms': 'Ҳозир ҳуҷра ёфтан →',
    'seo.crumb.home': 'Саҳифаи асосӣ',
    'seo.section.numbers': 'Дар рақамҳо',
    'seo.section.faq': 'Саволҳои зуд-зуд додашаванда',
    'seo.section.refs': 'Манбаъҳо',
    'seo.section.refsIntro':
      'Ҳар як рақами дар ин саҳифа ба манбаи аввалия ё манбаи дуюмдараҷаи эътимоднок такя мекунад. Маълумоти сайёҳии Осиёи Марказӣ зуд тағйир меёбад — рақамҳо ҳар сол санҷида шаванд.',
    'seo.section.cities': 'Шаҳрҳои дорои ҳуҷраҳои дастрас',
    'seo.section.cluster': 'Ҷойҳои тамаркузи ҳуҷраҳо',
    'seo.section.otherCities': 'Шаҳрҳои дигар дар {country}',
    'seo.section.guides': 'Дастурҳои мавзӯӣ',
    'seo.section.bycity': 'Аз рӯи шаҳрҳо',
    'seo.eyebrow.country': '{name} · Саҳифаи давлат',
    'seo.eyebrow.city': '{country} · Шаҳр',
    'seo.eyebrow.topic': 'Дастури мавзӯӣ',
    'seo.foot.uz': 'Ӯзбекистон',
    'seo.foot.topics': 'Мавзӯъҳо',
    'seo.foot.region': 'Минтақа',
    'seo.foot.about': 'Дар бораи',
    'seo.foot.tagline':
      'Ҳуҷраҳои соатӣ, рӯзона ва дар лаҳзаи охир дар тамоми Ӯзбекистон ва Осиёи Марказӣ. Дастрасӣ дар вақти воқеӣ, бе пешпардохт, дар меҳмонхона пардохт.',
    'seo.foot.bottom':
      'Ҳар як рақам дар матн бо манбаъ оварда мешавад ва дар поёни саҳифа ҷамъоварӣ мешавад.',
    'seo.foot.openapp': 'Кушодани барнома',
    'seo.lang.aria': 'Интихоби забон',
  },
  tm: {
    'sp.tag': 'Sagatlyk myhmanhanalar · Merkezi Aziýa',
    'sp.live.label': 'otag boş · 6 şäher',
    'sp.title.1': 'Gijäni geçiriň.',
    'sp.title.2.before': 'Bir ',
    'sp.title.2.hour': 'sagat',
    'sp.title.2.after': ' alyň.',
    'sp.lede':
      'Myhmanhanalar boş otaglary iň soňky pursatda berýärler. Häzir nämäniň boşdugyny görmek üçin şäher saýlaň.',
    'sp.pick': 'Şäher saýlaň',
    'sp.pick.cta': 'Başlamak üçin basyň',
    'sp.locate': 'Meniň ýerleşişim',
    'sp.locating': 'Kesgitlenýär…',
    'sp.trust': 'Goýumsyz · Mugt ýatyrma · Myhmanhanada töleg',
    'sp.live.unit': 'boş',
    'stories.title': 'Maslahat berilýän',
    'stories.cta': 'Otag bron etmek',
    'explore.title': 'Ýerleşiş we mowzuk boýunça',
    'explore.cities': 'Şäherler',
    'explore.topics': 'Mowzuklar',
    'explore.nearby': 'Golaýda',

    'top.city': 'Şäher',
    'top.day': 'Gündiz',
    'top.night': 'Şu gije',

    'card.left': '{n} galdy',
    'card.book': 'Almak',
    'card.window.day': '{win} · wagt saýlaň',
    'card.window.night': 'Şu gije · 1 gije',
    'card.dayblock': '{n} sagatlyk gündiz blogy',
    'card.empty.h': '{city} şäherinde saklanan otag ýok.',
    'card.empty.s':
      'Saklamak üçin haýsy hem bolsa otagdaky ýüregi basyň.',
    'card.empty.cta': 'Ähli otaglar →',

    'detail.book.day': 'Şu otagy bron etmek',
    'detail.book.night': 'Şu gije üçin almak',
    'detail.fine':
      'Goýumsyz · 1 sagat öň mugt ýatyrma · myhmanhanada töleg',
    'detail.window': 'Wagt',
    'detail.stay': 'Ýaşaýyş',
    'detail.mode': 'Tertip',
    'detail.dayuse': 'Gündiz · {n} sagat',
    'detail.overnight': 'Gije',
    'detail.tonight': 'Şu gije · 1 gije',
    'detail.rooms.left': '{n} otag galdy',
    'detail.tonight.tag': 'şu gije',

    'book.stay': 'Ýaşaýyş',
    'book.dayuse': 'Gündiz',
    'book.overnight': 'Gije',
    'book.when': 'Haçan',
    'book.guests': 'Myhmanlar',
    'book.guests.value': '2 uly adam',
    'book.saving': 'Tygşytlama',
    'book.youpay': 'Töleg',
    'book.confirm': 'Tassyklamak',
    'book.fine':
      'Goýumsyz · 1 sagat öň mugt ýatyrma · myhmanhanada töleg',
    'book.when.day': '{slot} · {n} sagat',

    'booked.t': 'Bron edildi',
    'booked.head': 'Taýyn!',
    'booked.code': 'Kabul ediş ýerinde şu kody görkeziň',
    'booked.pay': 'gelnende töleýärsiňiz',
    'booked.done': 'Ýapmak',
    'booked.confirmation': 'Tassyklama telefonyňyza iberildi.',

    'city.t': 'Şäher çalyşmak',
    'city.s': '6 şäherde boş otaglar',

    'settings.t': 'Sazlamalar',
    'settings.s': 'Dil we walýuta',
    'settings.lang': 'Dil',
    'settings.currency': 'Walýuta',
    'settings.done': 'Taýyn',

    'seo.cta.openapp': 'Programmany açmak →',
    'seo.cta.findRooms': 'Häzir otag tapmak →',
    'seo.crumb.home': 'Baş sahypa',
    'seo.section.numbers': 'Sanlarda',
    'seo.section.faq': 'Köp soralýan soraglar',
    'seo.section.refs': 'Çeşmeler',
    'seo.section.refsIntro':
      'Bu sahypadaky her bir san birinji ýa-da abraýly ikinji çeşmä salgylanýar. Merkezi Aziýadaky syýahatçylyk maglumatlary çalt üýtgeýär — sanlary her ýyl gaýtadan barlamak gerek.',
    'seo.section.cities': 'Boş otaglary bolan şäherler',
    'seo.section.cluster': 'Otaglaryň jemlenen ýerleri',
    'seo.section.otherCities': '{country} içindäki beýleki şäherler',
    'seo.section.guides': 'Mowzuk gollanmalary',
    'seo.section.bycity': 'Şäherler boýunça',
    'seo.eyebrow.country': '{name} · Ýurt sahypasy',
    'seo.eyebrow.city': '{country} · Şäher',
    'seo.eyebrow.topic': 'Mowzuk gollanma',
    'seo.foot.uz': 'Özbegistan',
    'seo.foot.topics': 'Mowzuklar',
    'seo.foot.region': 'Sebit',
    'seo.foot.about': 'Taslama hakda',
    'seo.foot.tagline':
      'Özbegistan we Merkezi Aziýa boýunça sagatlyk, gündizlik we iň soňky pursat otaglary. Hakyky wagtda boş otaglar, goýumsyz, myhmanhanada töleg.',
    'seo.foot.bottom':
      'Her bir san matnda çeşme bilen berilýär we sahypanyň aşagynda jemlenýär.',
    'seo.foot.openapp': 'Bron programmasy',
    'seo.lang.aria': 'Dil saýlamak',
  },
};

export function t(key, params = {}) {
  const dict = T[state.lang] || T.en;
  let str = dict[key] ?? T.en[key] ?? key;
  for (const k in params) {
    str = str.replace(new RegExp(`\\{${k}\\}`, 'g'), params[k]);
  }
  return str;
}

// Stateless variant for build-time SSR — pass in the language explicitly.
export function tFor(lang, key, params = {}) {
  const dict = T[lang] || T.en;
  let str = dict[key] ?? T.en[key] ?? key;
  for (const k in params) {
    str = str.replace(new RegExp(`\\{${k}\\}`, 'g'), params[k]);
  }
  return str;
}

// Multi-language field helper. Accepts either a plain string (treated as EN)
// or an object { en, uz, ru, kz, kg, tj, tm }. Falls back to EN, then the
// raw value if all else fails.
export function pick(field, lang) {
  if (field == null) return '';
  if (typeof field === 'string') return field;
  if (typeof field === 'object') return field[lang] || field.en || '';
  return String(field);
}

// ---------- currency ----------

const SOM = (n) => n.toLocaleString('en-US').replace(/,/g, '.');

const UNIT_LABEL = {
  UZS: { en: "so'm", uz: "so'm", ru: 'сум', kz: 'сум', kg: 'сум', tj: 'сум', tm: 'som' },
  USD: { en: '$', uz: '$', ru: '$', kz: '$', kg: '$', tj: '$', tm: '$' },
  EUR: { en: '€', uz: '€', ru: '€', kz: '€', kg: '€', tj: '€', tm: '€' },
  RUB: { en: '₽', uz: '₽', ru: '₽', kz: '₽', kg: '₽', tj: '₽', tm: '₽' },
};

export function formatPriceParts(uzs) {
  const cur = state.currency;
  const langKey = T[state.lang] ? state.lang : 'en';
  const unit = UNIT_LABEL[cur][langKey];
  if (cur === 'UZS') {
    return { num: SOM(uzs), unit, before: false };
  }
  const conv = uzs * RATES_FROM_UZS[cur];
  let num;
  if (cur === 'RUB') {
    num = Math.round(conv).toLocaleString('ru-RU');
  } else {
    num = conv.toFixed(2);
  }
  const before = cur === 'USD' || cur === 'EUR';
  return { num, unit, before };
}

export function formatPrice(uzs) {
  const { num, unit, before } = formatPriceParts(uzs);
  return before ? `${unit}${num}` : `${num} ${unit}`;
}

// Marker pin label — kept short for the map.
export function markerLabel(uzs) {
  const cur = state.currency;
  const conv = uzs * RATES_FROM_UZS[cur];
  if (cur === 'UZS') return Math.round(uzs / 1000) + 'k';
  if (cur === 'USD') return '$' + Math.round(conv);
  if (cur === 'EUR') return '€' + Math.round(conv);
  return Math.round(conv).toLocaleString('ru-RU') + '₽';
}

// ---------- amenities ----------

const AMEN_T = {
  'Wi-Fi': { en: 'Wi-Fi', uz: 'Wi-Fi', ru: 'Wi-Fi' },
  'A/C': { en: 'A/C', uz: 'Konditsioner', ru: 'Кондиционер' },
  Coffee: { en: 'Coffee', uz: 'Kofe', ru: 'Кофе' },
  Towels: { en: 'Towels', uz: 'Sochiqlar', ru: 'Полотенца' },
  Pool: { en: 'Pool', uz: 'Basseyn', ru: 'Бассейн' },
  Spa: { en: 'Spa', uz: 'SPA', ru: 'СПА' },
  Breakfast: { en: 'Breakfast', uz: 'Nonushta', ru: 'Завтрак' },
  Parking: { en: 'Parking', uz: 'Avtoturargoh', ru: 'Парковка' },
  Gym: { en: 'Gym', uz: 'Sport zali', ru: 'Спортзал' },
  Bar: { en: 'Bar', uz: 'Bar', ru: 'Бар' },
  Workspace: { en: 'Workspace', uz: 'Ish joyi', ru: 'Рабочее место' },
};

export function amenLabel(a) {
  const t = AMEN_T[a];
  if (!t) return a;
  return t[state.lang] || t.en || a;
}

// ---------- city meta ----------

const CITY_META_T = {
  Tashkent: {
    en: 'Capital · UTC+5',
    uz: 'Poytaxt · UTC+5',
    ru: 'Столица · UTC+5',
  },
  Samarkand: {
    en: 'Registan · Silk Road',
    uz: "Registon · Buyuk Ipak yo'li",
    ru: 'Регистан · Шёлковый путь',
  },
  Bukhara: {
    en: 'Old town · Lyabi-Hauz',
    uz: 'Eski shahar · Labihovuz',
    ru: 'Старый город · Ляби-Хауз',
  },
  Khiva: {
    en: 'Ichan Qala · walled city',
    uz: 'Ichan Qala · qadimiy shahar',
    ru: 'Ичан-Кала · крепость',
  },
  Fergana: {
    en: 'Valley · east',
    uz: 'Vodiy · sharq',
    ru: 'Долина · восток',
  },
  Nukus: {
    en: 'Karakalpakstan · west',
    uz: "Qoraqalpog'iston · g'arb",
    ru: 'Каракалпакстан · запад',
  },
};

export function cityMetaLabel(c) {
  const t = CITY_META_T[c];
  if (!t) return '';
  return t[state.lang] || t.en || '';
}
